var map = {
	"./bookBeauty.png": "8632",
	"./expirenza.png": "7ac2",
	"./glovo.png": "b8bf",
	"./hallScreen.png": "8611",
	"./icon-site.webp": "8017",
	"./kitchenScreen.png": "6854",
	"./loyallyst.png": "20a6",
	"./monobank.png": "6a76",
	"./posterminal.png": "bd3a",
	"./privatbank.png": "ec86",
	"./qrmenupay.png": "f6e4",
	"./sendcheck.jpeg": "a0e0",
	"./skymarket.jpeg": "ccbd",
	"./stopList.png": "a65c",
	"./warehouseRequest.png": "015f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "521e";